import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, Card, Tabs } from 'antd';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { CollectionServer, DropdownAction, GET, JSXMap, POST, QueryDetail, QueryOrder, QueryParam, deleteInArray, errorCatch, getObjectDisplay, uncapitalize, updateInArray, useAuth, useMetaContext } from 'fennec-ui'
import AbstractCollection from '../../../common/AbstractCollection';
import confirmKey from '../../components/ConfirmKeyModal';
import { Model } from 'fennec-ui';
import Icofont from 'react-icofont';
import PageLayout from '../../components/PageLayout';
var _ = require('lodash');
const { TabPane } = Tabs;

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

export default function FederationadministratorSettingsFsm(props) {
    const auth = useAuth()
    const meta = useMetaContext()

    const filtersFromMeta = React.useCallback((name) => {
        let prop = [];
        let p = _.get(meta[name], "properties");
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);

    const cleanProperties = (obj) => {
        let p = []
        if (obj && _.isArray(obj)) {
            p = [...obj]
        } else if (obj && _.isObject(obj)) {
            p = [...obj?.properties]
        }
        
        p = p.filter(n => n.name !== "CreatedAt" && n.name !== "UpdatedAt" && n.name !== "DeletedAt")
        p = p.map(n => (n.type == "object")? {
            ...n, 
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("ID", "ASC"),
            ],
            dropdownActions: (value, item, meta) => {
                let name = item?.relation?.reference?.object;
                let m = meta[name]
            
                return [{
                    title: "Создать",
                    form: Model,

                    links: true,
                    defaultModelActions: true,
                    defaultModelActionMeta: (mobject, item) => cleanProperties(mobject),
                    defaultCollectionActions: true,
                    defaultCollectionActionMeta: (mobject) => cleanProperties(mobject),

                    meta: cleanProperties(m),
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        POST(auth, `/api/query-create/${name}`, { ...values },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                },
            ]}
        }:n)
        p = p.map(n => (n.type == "string" && !n?.db?.size) ? {
            ...n,
            type: "text"
        } : n)
        return (obj && _.isArray(obj))?p:{...obj, properties: p}
    }
    return (
        <PageLayout>
            <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
                <Tabs defaultActiveKey="system-services">
                    <TabPane key="system-services" tab={"Сервисы"}>
                        <CollectionServer
                            auth={auth}
                            name={"FsmServices"}
                            filters={() => filtersFromMeta("FsmServices")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "FsmServices", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            linksModelActions={true}
                            
                            queryDetail={"collection"}
                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject)}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject)}
                        />
                    </TabPane>
                    <TabPane key="system-questions" tab={"Вопросы"}>
                        <CollectionServer
                            auth={auth}
                            name={"FsmQuestions"}
                            filters={() => filtersFromMeta("FsmQuestions")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "FsmQuestions", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            linksModelActions={true}
                            
                            queryDetail={"collection"}
                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject)}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject)}
                        />
                    </TabPane>
                    <TabPane key="system-answers" tab={"Ответы"}>
                        <CollectionServer
                            auth={auth}
                            name={"FsmAnswers"}
                            filters={() => filtersFromMeta("FsmAnswers")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "FsmAnswers", meta)}</div>
                                    {item?.question && <div style={{ color: "#6a6a6a" }}>{getObjectDisplay(item?.question, "FsmQuestions", meta)}</div>}
                                </div>
                            )}

                            linksModelActions={true}
                            
                            queryDetail={"collection"}
                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject)}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject)}
                        />
                    </TabPane>
                    <TabPane key="system-states" tab={"Состояния"}>
                        <CollectionServer
                            auth={auth}
                            name={"FsmStates"}
                            filters={() => filtersFromMeta("FsmStates")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "FsmStates", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            linksModelActions={true}
                            
                            queryDetail={"collection"}
                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject)}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject)}
                        />
                    </TabPane>
                    <TabPane key="system-functions" tab={"Функции"}>
                        <CollectionServer
                            auth={auth}
                            name={"FsmFunctions"}
                            filters={() => filtersFromMeta("FsmFunctions")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "FsmFunctions", meta)}</div>
                                    {item?.question && <div style={{ color: "#6a6a6a" }}>{getObjectDisplay(item?.question, "FsmQuestions", meta)}</div>}
                                </div>
                            )}

                            linksModelActions={true}
                            
                            queryDetail={"collection"}
                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject)}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject)}
                        />
                    </TabPane>
                    <TabPane key="system-scheme" tab={"Схемы"}>
                        <CollectionServer
                            auth={auth}
                            name={"FsmScheme"}
                            filters={() => filtersFromMeta("FsmScheme")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "FsmScheme", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            linksModelActions={true}
                            
                            queryDetail={"collection"}
                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject)}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject)}
                        />
                    </TabPane>
                    <TabPane key="system-groups" tab={"Группы"}>
                        <CollectionServer
                            auth={auth}
                            name={"FsmGroups"}
                            filters={() => filtersFromMeta("FsmGroups")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "FsmGroups", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}
                            
                            linksModelActions={true}
                            
                            queryDetail={"collection"}
                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject)}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject)}
                        />
                    </TabPane>
                    <TabPane key="system-context" tab={"Контексты"}>
                        <CollectionServer
                            auth={auth}
                            name={"FsmContext"}
                            filters={() => filtersFromMeta("FsmContext")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "FsmContext", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}
                            
                            linksModelActions={true}
                            
                            queryDetail={"collection"}
                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject)}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject)}
                        />
                    </TabPane>
                    <TabPane key="system-context-type" tab={"Типы контекстов"}>
                        <CollectionServer
                            auth={auth}
                            name={"FsmContextType"}
                            filters={() => filtersFromMeta("FsmContextType")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "FsmContextType", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}
                            
                            linksModelActions={true}
                            
                            queryDetail={"collection"}
                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject)}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject)}
                        />
                    </TabPane>
                </Tabs>
            </div>
        </PageLayout >
    );
}